import { NODE_TYPE } from "src/constants/NodeTypes";
import {
  useJobRunCountsForNode,
  useOutputNodeJobRunCounts,
} from "src/flowGraph/useJobRunCounts";
import { getJobRunFlags, JobRun } from "src/jobs/types";
import { useGraphStore } from "src/store/StoreProvider";

export const useJobRunNodeStatusCounts = (jobRun: JobRun) => {
  const { selectedNode } = useGraphStore();

  const { isJobRunning } = getJobRunFlags(jobRun.status.type);

  const isOutputNode = selectedNode?.type === NODE_TYPE.OUTPUT_NODE;

  const perNodeCounts = useJobRunCountsForNode(selectedNode?.id ?? "");
  const outputCounts = useOutputNodeJobRunCounts();
  const jobRunCounts = isOutputNode ? outputCounts : perNodeCounts;

  const totalCount = (() => {
    if (isOutputNode) {
      return outputCounts?.total ?? 0;
    }

    if (!perNodeCounts) {
      return 0;
    }

    return (
      perNodeCounts.success +
      perNodeCounts.failed +
      perNodeCounts.ignored +
      perNodeCounts.pending +
      perNodeCounts.cancelled +
      perNodeCounts.other
    );
  })();

  return {
    isJobRunning,
    isPolling: typeof perNodeCounts === "undefined",
    successCount: jobRunCounts?.success ?? 0,
    failureCount: jobRunCounts?.failed ?? 0,
    ignoredCount: jobRunCounts?.ignored ?? 0,
    outputMismatchCount: jobRunCounts?.output_mismatch ?? 0,
    totalCount,
  };
};
